"use client";

import { useState } from "react";
import { Button } from "@tillix/ui-atoms/button";
import { Card } from "@tillix/ui-atoms/card";
import { FieldControl, FieldLabel, FieldRoot } from "@tillix/ui-atoms/field";
import { Input } from "@tillix/ui-atoms/input";

const ACCEPTED_ZIP = "10118";

interface NigoGateProps {
  children: React.ReactNode;
}

export default function NigoGate({ children }: NigoGateProps) {
  const [verified, setVerified] = useState(false);
  const [zip, setZip] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (zip.trim() === ACCEPTED_ZIP) {
      setVerified(true);
    } else {
      setError("The ZIP code you entered does not match our records.");
    }
  };

  if (verified) {
    return <>{children}</>;
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>Verify Your Identity</Card.Title>
        <Card.Description>
          Please enter your ZIP code to access your NIGO work items.
        </Card.Description>
      </Card.Header>
      <Card.Content>
        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
          <FieldRoot invalid={!!error} name="verifyZip">
            <FieldLabel>ZIP Code</FieldLabel>
            <FieldControl
              render={(defaultProps) => (
                <Input
                  {...defaultProps}
                  autoFocus={true}
                  className={defaultProps.className ?? ""}
                  inputMode="numeric"
                  maxLength={5}
                  onChange={(e) => {
                    setZip(e.target.value);
                    setError("");
                  }}
                  placeholder="Enter your ZIP code"
                  style={defaultProps.style ?? {}}
                  value={zip}
                />
              )}
            />
            {error && (
              <p className="font-medium text-[0.8rem] text-destructive">
                {error}
              </p>
            )}
          </FieldRoot>
          <Button disabled={zip.trim().length === 0} type="submit">
            Continue
          </Button>
        </form>
      </Card.Content>
    </Card>
  );
}
